import i18n from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import { initReactI18next } from 'react-i18next'

import { resources } from './src/i18n'

i18n.use(LanguageDetector)
    .use(initReactI18next)
    .init({
        debug: process.env.NODE_ENV === 'development',
        fallbackLng: 'hr',
        interpolation: {
            escapeValue: false,
        },
        detection: {
            order: ['localStorage', 'navigator'],
            caches: ['localStorage'],
        },

        ns: [
            'accreditation',
            'auth',
            'common',
            'competition',
            'general-applications',
            'league',
            'match',
            'notification',
            'organization',
            'phase',
            'recreation',
            'roles',
            'season',
            'shared',
            'sponsor',
            'sport',
            'unit',
            'user',
            'utils',
        ],
        defaultNS: 'common',
        resources,
    })

export default i18n
